import Cookies from 'js-cookie';
import store from '../../redux/store';
class TokenService {
    getLocalRefreshToken() {
        const refresh = Cookies.get('refresh');
        // Migrate existing cookie to have secure/sameSite attributes
        if (refresh) {
            this.migrateCookieSecurity(refresh);
        }
        return refresh;
    }

    getLocalAccessToken() {
        const user = JSON.parse(localStorage.getItem('user'));
        return user?.access;
    }

    updateLocalAccessToken(token) {
        let user = JSON.parse(localStorage.getItem('user'));
        user.access = token;

        localStorage.setItem('user', JSON.stringify(user));
    }

    getUser() {
        return JSON.parse(localStorage.getItem('user'));
    }

    setUser(user) {
        Cookies.set('refresh', user.refresh, {
            secure: true,
            sameSite: 'strict',
        });

        // localStorage.setItem('user', JSON.stringify(user.access))
    }

    /**
     * Migrates existing cookies to have secure and sameSite attributes
     * This ensures old cookies get updated with new security settings
     */
    migrateCookieSecurity(refreshToken) {
        if (!refreshToken) return;

        // Re-set the cookie with security attributes
        // This will update the existing cookie with new attributes
        Cookies.set('refresh', refreshToken, {
            secure: true,
            sameSite: 'strict',
        });
    }

    removeUser() {
        localStorage.clear();
    }
}

export default new TokenService();
